export default __webpack_public_path__ + "static/media/1715.861b66e8.png";